"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _common;
var _default = exports.default = {
  common: (_common = {
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    confirm: 'Confirm',
    complete: 'Complete',
    back: 'Back',
    submit: 'Submit',
    search: 'Search',
    reset: 'Reset',
    create: 'Create',
    add: 'Add',
    check: 'Check',
    checkin: 'Check-in',
    auth: 'Authorize',
    edit: 'Edit',
    checkResult: 'Check Result',
    saveErrorMessage: 'Save Failed',
    exportResult: 'Export Result',
    errorInfo: 'Error Info',
    viewParam: 'View Parameter',
    viewAccount: 'View Account',
    datetimeSearch: 'Search date and time',
    to: 'To',
    startDatetime: 'Start Time',
    EndDatetime: 'End Time',
    selectDatetime: 'Select Date',
    delete: 'Delete',
    DELETED: 'Deleted',
    modifyPass: 'Modify Password',
    roleAuth: 'Authorize Roles',
    distributeAuth: 'Distribute Authority',
    checkAuthDetail: 'Authority Details',
    checkDetail: 'Check Details',
    enable: 'Enable',
    enabled: 'Enabled',
    disabled: 'Disabled',
    locked: 'Locked',
    ENABLE: 'Enable',
    DISABLED: 'Disabled',
    ENABLED: 'Enabled',
    LOCKED: 'Locked',
    more: 'View More',
    tip: 'Tip',
    enableSuccess: 'Enable Successfully',
    enableFail: 'Enable Failed',
    disableSuccess: 'Disable Successfully',
    disableFail: 'Disable Failed',
    disabledSuccess: 'Disable Successfully',
    disabledFail: 'Disable Failed',
    authSuccess: 'Authorize Successfully',
    authFail: 'Authorize Failed',
    saveSuccess: 'Save Successfully',
    saveDraftSuccess: 'Draft save successfully',
    updateSuccess: 'Update Successfully',
    deleteSuccess: 'Delete Successfully',
    resetSuccess: 'Reset Successfully',
    checkinSuccess: 'Check-in Successfully',
    uploadSuccess: 'Upload Successfully',
    uploadError: 'Upload Failed',
    confirm1: 'Are you sure to delete it?',
    confirm2: 'Are you sure to disable this menu?',
    confirm3: 'Are you sure to enable this menu?',
    confirm4: 'Are you sure to delete this menu?',
    confirm5: 'Are you sure to disable it?',
    confirm6: 'Are you sure to enable it?',
    confirm7: 'Are you sure to reset this token?',
    confirm8: 'Are you sure to disable this user?',
    confirm9: 'Are you sure to ensable this user?',
    confirm10: 'Are you sure to delete this user?',
    confirm11: 'There are modifications have not been saves, are you sure to quit?',
    confirm12: "Are you sure to reset this user's password?",
    confirm13: 'Are you sure to modify password?',
    confirm14: 'Are you sure to save the modify?',
    preciseQuery: 'Precise query',
    fuzzyQuery: 'Fuzzy query',
    resetToken: 'Reset Token',
    export: 'Export',
    exportCarSubsidy: 'CarSubsidy',
    exportMealSupplement: 'MealSupplement',
    exportDetail: 'Export Detail',
    exportAll: 'Export All History',
    print: 'Print',
    preview: 'Preview',
    import: 'Import',
    resetFile: 'Reselect File',
    pleaseInput: 'Please input',
    pleaseSelect: 'Please select',
    pleaseSelectOrInput: 'Please select or input',
    previousStep: 'Previous Step',
    nextStep: 'Next Step'
  }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_common, "back", 'Back'), "next", 'Next'), "saveDraft", 'Save As Draft'), "clickUpload", 'Click To Upload'), "switchLang", 'Language switch succeed'), "Monday", 'Monday'), "Tuesday", 'Tuesday'), "Wednesday", 'Wednesday'), "Thursday", 'Thursday'), "Friday", 'Friday'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_common, "Saturday", 'Saturday'), "Sunday", 'Sunday'), "systemPk", 'No.'), "year", 'Year'), "month", 'Month'), "day", 'Day'), "startDate", 'Start Date'), "startTime", 'Start Time'), "endDate", 'End Date'), "endTime", 'End Time'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_common, "selectTimeRange", 'Select time range'), "uploadLimit50M", 'Please upload image smaller than 50MB'), "uploadLimitDesc1", 'Please upload image smaller than '), "uploadLimitDesc2", 'MB'), "uploadImage", 'Upload Image'), "dragImageHere", 'Drag the file here'), "exportReport", 'Export Report'), "exportRange", 'Export Range'), "execute", 'Execute'), "action", 'Action'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_common, "comment", 'COMMENT'), "send", 'SEND'), "total", 'Total'), "list", 'List'), "brand", 'Brand'), "year2", 'Year'), "date", 'Date'), "province", 'Province'), "city", 'City'), "area", 'District'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_common, "paramError", 'Params Error'), "errorInfo", 'Error'), "yes", 'Yes'), "no", 'No'), "provinceCity", 'Province/City')),
  /* route default lowercase */
  route: {
    dashboard: 'Dashboard',
    errorPages: 'Error Page',
    page401: '401',
    page404: '404',
    profile: 'Profile',
    functionmodule: 'Function Module',
    sysconfig: 'System Configuration',
    business: 'Business System',
    lookup: 'Value Lookup',
    interfaceinfo: 'Interface Info ',
    interfaceuser: 'Interface User',
    role: 'Role',
    sysuser: 'System User',
    functionlist: 'Function List',
    menulist: 'Menu List',
    logmodule: 'Log Module',
    apilog: 'Api Log',
    calllog: 'Api Call Log',
    loginlog: 'Login Log',
    emailmodule: 'Email Management Module',
    emailconfig: 'Email Server Configuration Management',
    emailtemplate: 'Email Template Management',
    smsmodule: 'Sms Module',
    smstemplate: 'Sms Template Management',
    smschannel: 'Sms Channel Management',
    userclassification: 'User Classification Management',
    doubleweekplan: 'Planning and Task',
    storemodule: 'Retailor',
    cpstoremodule: 'CP Retailor',
    srstorelist: 'Store',
    cpstorelist: 'CP Store',
    dastorelist: 'Retailor And SR Relationship',
    planmodule: 'Plan Management',
    storevisitreport: 'Store Visit Report',
    taskschedulelog: 'Task Log',
    taskassignmentmodule: 'Task Assignment Module'
  },
  navbar: {
    dashboard: 'Dashboard',
    github: 'Github',
    changeRole: 'Change Role',
    changeRole_success: 'Change role successfully',
    changeRole_fail: 'Change role failed',
    changeRole_noPermission: 'Please use APP for better user experience',
    logOut: 'Logout',
    profile: 'Profile',
    theme: 'Theme',
    size: 'Size',
    system: 'System',
    taskList: 'Task List',
    likeCommentList: 'Like Comment List'
  },
  login: {
    title: 'Welcome To SFE Management Backstage',
    welcome: 'Welcome',
    logIn: 'Login',
    login: 'Login',
    ssoLogin: 'SSO Login',
    username: 'Username',
    password: 'Password',
    code: 'Code',
    remember: 'Remeber The Password',
    selectRole: 'Please select a role to sign in',
    selectRolePlaceholder: 'Please Select Role Placeholder',
    backToLogin: 'Back',
    enterSystem: 'Submit',
    redirectError: 'Token expired, please login again',
    placeholder: {
      username: 'Please Enter Username',
      password: 'Please Enter Password',
      code: 'Please Enter The Code In The Box'
    },
    error: {
      username: 'Please Enter Valid Username',
      password: 'Please Enter Valid Password',
      code: 'Please Enter The Correct Code'
    }
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close others',
    closeAll: 'Close all'
  },
  profile: {
    action: 'User Action'
  },
  settings: {
    title: 'System title',
    theme: 'Theme color',
    tagsView: 'Open Tags-View',
    fixedHeader: 'Fixed Header',
    sidebarLogo: 'Sidebar Logo'
  },
  errorMsg: {
    400: 'Request error',
    401: 'Unauthorized, please login',
    403: 'Access denied',
    404: 'Request address error',
    408: 'Request timeout',
    500: 'Internal server error',
    501: 'Service not implemented',
    502: 'Gateway error',
    503: 'Service not available',
    504: 'Gateway timeout',
    505: 'HTTP version not supported',
    timeout: 'Connection timeout, please try again',
    loginFail: 'Login Failed'
  },
  errorValid: {
    formError: 'Please fill in all the mandatory fields',
    empty: 'Please enter',
    emptyPhone: 'Please enter the phone number',
    emptySelect: 'Please select',
    emptyUpload: 'Please upload',
    validMultiFile: 'The number of uploads exceeds the limit, with a maximum of',
    validPhone: 'Please enter a valid phone number',
    validNumber: 'Please enter a valid number',
    validText: 'Please enter valid text',
    validFloat: 'Please enter a valid numerical value',
    validPatt: 'Please enter a valid percentage with 2 decimal places',
    form: 'Please check the form content',
    startTime: 'Please choose start time',
    endTime: 'Please choose end time',
    emptyProject: 'Please click at least one of the Tire/No-tire,or fill in Other services'
  },
  MessageBox: {
    logOut: {
      title: 'Confirm Logout',
      content: 'You have logged out, you can click cancel to stay on this page or re-login',
      confirm: 'Re-login'
    }
  },
  Progress: {
    readData: 'Reading Data',
    checkHeader: 'Checking Header',
    checkData: 'Checking Data',
    importData: 'Importing Data',
    wait: 'Waiting',
    progress: 'In Progress',
    complete: 'Completed',
    fail: 'Failed, please retry'
  },
  sysconfig: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Config List'
    },
    input: {
      configType: 'Config Type',
      configTypeHolder: 'Precise query',
      configCode: 'Config Code',
      configCodeHolder: 'Fuzzy query'
    },
    table: {
      systemConfigPk: 'No.',
      configType: 'Config Type',
      configCode: 'Config Code',
      configVal: 'Config Value',
      sequence: 'Sequence',
      remark: 'Remark',
      action: 'Action'
    },
    form: {
      configType: 'Config Type',
      configCode: 'Config Code',
      configVal: 'Config Value',
      sn: 'No.',
      remark: 'Remark'
    },
    error: {
      configType: 'Please input valid config type',
      configCode: 'Please input valid config code',
      configVal: 'Please input valid config value',
      sn: 'Please input valid number'
    }
  },
  business: {
    BoxWrap: {
      manage: 'Business System Management',
      list: 'System List'
    },
    table: {
      sequence: 'No.',
      sysName: 'System Name',
      indexUrl: 'Homepage URL',
      appIdentification: 'App Identification',
      state: 'State',
      createName: 'Creator',
      createTime: 'Create Time',
      lastUpdateTime: 'Update Time',
      action: 'Action'
    },
    form: {
      sysName: 'System Name',
      indexUrl: 'Homepage URL',
      sn: 'No.',
      remark: 'Remark'
    },
    error: {
      sysName: 'Please input valid system name',
      indexUrl: 'Please input valid homepage URL',
      sn: 'Please input valid number'
    }
  },
  lookup: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Value List'
    },
    input: {
      typeName: 'Type Name',
      typeNameHolder: 'Precise query',
      typeCode: 'Type Code',
      typeCodeHolder: 'Fuzzy query'
    },
    table: {
      sequence: 'No.',
      typeName: 'Type Name',
      typeCode: 'Type Code',
      remark: 'Remark',
      action: 'Action',
      valueCode: 'Lookup Value Code',
      valueName: 'Lookup Value Name',
      state: 'State'
    },
    dropdown: {
      view: 'View'
    },
    form: {
      typeName: 'Type Name',
      typeCode: 'Type Code',
      remark: 'Remark',
      action: 'Action',
      searchCode: 'Lookup Value Code',
      searchName: 'Lookup Value Name',
      searchState: 'Lookup Value State'
    },
    error: {
      typeName: 'Please input valid type name',
      typeCode: 'Please input valid type code',
      sn: 'Please input valid number',
      valueName: 'Please input valid lookup value name',
      valueCode: 'Please input valid lookup value code'
    }
  },
  interfaceInfo: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Interface List'
    },
    input: {
      interfaceNo: 'Interface Number',
      interfaceNoHolder: 'Precise query',
      interfaceName: 'Interface Name',
      interfaceNameHolder: 'Fuzzy query'
    },
    table: {
      sequence: 'No.',
      interfaceNo: 'Interface Number',
      interfaceName: 'Interface Name',
      state: 'State',
      remark: 'Remark',
      action: 'Action'
    },
    form: {
      interfaceNo: 'Interface Number',
      interfaceName: 'Interface Name',
      interfaceType: 'Interface Type',
      remark: 'Remark'
    },
    error: {
      interfaceNo: 'Please input valid interface number',
      interfaceName: 'Please input valid interface name',
      interfaceType: 'Please input valid interface type',
      sn: 'Please input valid number'
    }
  },
  interfaceUser: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'User List'
    },
    input: {
      interfaceUser: 'Interface User',
      interfaceUserHolder: 'Interface User'
    },
    dialog: {
      interfaceUserAuth: 'Interface User Authorization',
      checkAuth: 'View Authorization'
    },
    table: {
      sequence: 'No.',
      userAuthVos: 'Authorized Interface Info',
      interfaceNo: 'Interface Number',
      interfaceName: 'Interface Name',
      state: 'State',
      userName: 'User Name',
      userType: 'User Type',
      loginCode: 'Login Code',
      userMobile: 'Mobile Number',
      createBy: 'Creator',
      createTime: 'Create Time',
      lastUpdateTime: 'Update Time',
      action: 'Action'
    },
    dropdown: {
      userAuth: 'User Authorization',
      viewToken: 'View Token'
    },
    form: {
      authToken: 'Credential Token',
      userName: 'User Name',
      loginCode: 'Login Code',
      userMobile: 'Mobile Number',
      remark: 'Remark'
    },
    error: {
      userName: 'Please input valid user name',
      loginCode: 'Please input valid login code',
      userMobile: 'Please input valid mobile number',
      remark: 'Please input valid remark'
    }
  },
  role: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Role List'
    },
    input: {
      roleName: 'Role Name',
      roleNameHolder: 'Precise query',
      roleCode: 'Role Code',
      roleCodeHolder: 'Fuzzy query'
    },
    table: {
      sequence: 'No.',
      roleName: 'Role Description',
      roleCode: 'Role Name',
      createTime: 'Create Date',
      createName: 'Create by',
      menuName: 'Menu Name',
      functionList: 'Function List',
      action: 'Action'
    },
    dropdown: {
      checkAuthDetail: 'Authority Details',
      roleAuth: 'Assign Authority',
      deleteItem: 'Delete'
    },
    form: {
      roleName: 'Role Description',
      roleCode: 'Role Name',
      remark: 'Remark'
    },
    error: {
      roleName: 'Please input valid role description',
      roleCode: 'Please input valid role name',
      sn: 'Please input valid number'
    }
  },
  sysUser: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'User List'
    },
    input: {
      userName: 'User Name',
      userNameHolder: 'Precise query',
      userClassification: 'User Group',
      userClassificationHolder: 'Please select from dropdown',
      employeeNumber: 'Employee ID',
      phoneNumber: 'Mobile Number',
      email: 'Email',
      isApply: 'Is enabled',
      role: 'Role'
    },
    table: {
      sequence: 'No.',
      employeeNumber: 'Employee ID',
      userName: 'User Name',
      role: 'Role',
      phone: 'Mobile',
      email: 'Email',
      isApply: 'Is Enabled',
      action: 'Action',
      loginCode: 'Login Code',
      loginModule: 'Login Mode',
      userClassification: 'User Group',
      extOne: 'Carrier',
      userMobile: 'Mobile Number',
      state: 'State',
      createName: 'Creator',
      createTime: 'Create Time',
      lastUpdateTime: 'Update Time',
      remark: 'Remark',
      roleName: 'Role Name'
    },
    dropdown: {
      resetPassword: 'Reset Password',
      modifyPassword: 'Modify Password',
      checkAuthDetail: 'Authority Details',
      roleAuth: 'Role Authorization',
      deleteItem: 'Delete'
    },
    form: {
      select: 'Please select',
      loginCode: 'Login Code',
      loginModule: 'Login Module',
      userClassification: 'User Group',
      extOne: 'Carrier',
      userName: 'User Name',
      userMobile: 'Mobile Number',
      userEmail: 'Email',
      remark: 'Remark',
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password'
    },
    error: {
      loginCode: 'Please input valid login code',
      loginModule: 'Please select valid login mode',
      userClassification: 'Please select valid user group',
      extOne: 'Please select carrier',
      userName: 'Please input valid user name',
      userMobile: 'Please input valid mobile number',
      userEmail: 'Please input valid email address',
      sn: 'Please input valid number',
      oldPassword: 'Please input valid original password',
      newPassword: 'Please input valid new password',
      confirmPassword: 'Confirm password does not match new password'
    }
  },
  functionList: {
    BoxWrap: {
      list: 'Function List'
    },
    table: {
      sequence: 'No.',
      menuName: 'Menu Name',
      functionList: 'Function List',
      functionName: 'Function Name',
      functionCode: 'Function Code',
      functionBindNos: 'Related Interfaces',
      state: 'State',
      functionListAction: 'Fuction List Action',
      action: 'Action'
    },
    form: {
      functionName: 'Function Name',
      functionCode: 'Function Code',
      functionBindNos: 'Related Interfaces',
      remark: 'Remark'
    },
    error: {
      functionName: 'Please input valid function name',
      functionCode: 'Please input valid function code',
      functionBindNos: 'Please input valid associated interfaces',
      sn: 'Please input valid number'
    }
  },
  menuList: {
    BoxWrap: {
      manage: 'Menu Management',
      list: 'Menu List'
    },
    table: {
      sequence: 'No.',
      menuName: 'Menu Name',
      menuCode: 'Menu Code',
      menuUrl: 'Menu URL',
      isTop: 'Is Top',
      isVirtual: 'Is Virtual',
      state: 'State',
      createTime: 'Create Time',
      action: 'Action'
    },
    form: {
      yes: 'Yes',
      no: 'No',
      N: 'Menu',
      V: 'Virtual Menu',
      R: 'Route Menu',
      parentMenuName: 'Parent Menu Name',
      menuName: 'Menu Name',
      menuCode: 'Menu Code',
      menuUrl: 'Menu URL',
      menuIcon: 'Menu Icon',
      component: 'Component',
      isTop: 'is Top',
      isVirtual: 'Menu Type',
      sn: 'No.',
      remark: 'Remark'
    },
    error: {
      menuName: 'Please enter a valid menu name',
      menuCode: 'Please enter a valid menu code',
      menuUrl: 'Please enter a valid menu URL',
      menuIcon: 'Please enter a valid menu icon',
      component: 'Please enter a valid menu component',
      remark: 'Please enter a valid remark',
      sn: 'Please enter a valid number'
    }
  },
  callLog: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Log List'
    },
    input: {
      interfaceSn: 'Interface Number',
      interfaceSnHolder: 'Exact query',
      errorCode: 'Error Code',
      errorCodeHolder: 'Exact query',
      detailErrorCode: 'Detail Error Code',
      detailErrorCodeHolder: 'Exact query',
      startTime: 'Start Time',
      startTimeHolder: 'Select date',
      endTime: 'End Time',
      endTimeHolder: 'Select date',
      systemSuffix: 'System Suffix'
    },
    table: {
      systemPk: 'No.',
      interfaceSn: 'Interface Number',
      url: 'URL',
      errorCode: 'Error Code',
      detailErrorCode: 'Detail Error Code',
      loginCode: 'Login Code',
      ipAddr: 'IP',
      consumeTime: 'Consume Time (ms)'
    },
    form: {
      systemPk: 'No.',
      externalLogPk: 'External Interface Number',
      perms: 'Owner',
      interfaceSn: 'Interface Number',
      url: 'URL',
      requestMethod: 'Request Method',
      errorCode: 'Error Code',
      detailErrorCode: 'Detail Error Code',
      extAttr1: 'Extra Attribute 1',
      extAttr2: 'Extra Attribute 2',
      extAttr3: 'Extra Attribute 3',
      extAttr4: 'Extra Attribute 4',
      loginCode: 'Login Code',
      ipAddr: 'IP',
      interfaceParamJson: 'Path Parameters',
      interfaceResponseJson: 'Response Data',
      reqTime: 'Request Time',
      userAgent: 'User Agent',
      consumeTime: 'Consume Time (ms)'
    }
  },
  loginLog: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Log List'
    },
    input: {
      loginCode: 'Login Code',
      loginCodeHolder: 'Exact Query',
      ipAddr: 'IP Address',
      ipAddrHolder: 'Fuzzy query',
      startTime: 'Start Time',
      startTimeHolder: 'Select date',
      endTime: 'End Time',
      endTimeHolder: 'Select date'
    },
    table: {
      systemPk: 'No.',
      sessionid: 'Session Id',
      loginInDatetime: 'Login Time',
      loginOutDatetime: 'Logout Time',
      loginCode: 'Login Code',
      ipAddr: 'IP',
      loginLogPk: 'Log Number',
      userPk: 'User Number',
      unionid: 'UnionId',
      remark: 'Remark',
      extAttr: 'Status'
    }
  },
  apiLog: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Log List'
    },
    input: {
      interfaceSn: 'Interface Number',
      interfaceSnHolder: 'Exact query',
      errorCode: 'Error Code',
      errorCodeHolder: 'Exact query',
      detailErrorCode: 'Detail Error Code',
      detailErrorCodeHolder: 'Exact query',
      systemSuffix: 'System Suffix'
    },
    table: {
      sequence: 'No.',
      interfaceSn: 'Interface Number',
      loginCode: 'Login Code',
      errorCode: 'Error Code',
      detailErrorCode: 'Detail Error Code',
      ipAddr: 'IP',
      url: 'URL',
      consumeTime: 'Consume Time (ms)',
      action: 'Action'
    },
    form: {
      systemPk: 'No.',
      interfaceLogPk: 'Interface Number',
      perms: 'Owner',
      startTime: 'Start Time',
      endTime: 'End Time',
      interfaceSn: 'Interface Number',
      url: 'URL',
      fullUrl: 'Full URL',
      urlPattern: 'URL Pattern',
      referer: 'Referer',
      requestMethod: 'Request Method',
      errorCode: 'Error Code',
      detailErrorCode: 'Detail Error Code',
      extAttr1: 'Extra Attribute 1',
      extAttr2: 'Extra Attribute 2',
      extAttr3: 'Extra Attribute 3',
      extAttr4: 'Extra Attribute 4',
      queryString: 'Query String',
      token: 'Token',
      ipAddr: 'IP',
      pathVariable: 'Path Parameters',
      reqTime: 'Request Time',
      consumeTime: 'Consume Time (ms)',
      interfaceParamJson: 'Interface Parameters',
      interfaceResponseJson: 'Response Data',
      loginCode: 'Login Code',
      userAgent: 'User Agent',
      sessionId: 'Session Id'
    }
  },
  emailConfig: {
    BoxWrap: {
      manage: 'Config Query',
      list: 'Config List'
    },
    input: {
      emailName: 'Email Server Name',
      emailNameHolder: 'Exact query',
      emailStatus: 'Email Server Status',
      emailStatusHolder: 'Fuzzy query',
      emailType: 'Email Type',
      emailTypeHolder: 'Fuzzy query',
      emailGroup: 'Email Server Group',
      emailGroupHolder: 'Fuzzy query'
    },
    table: {
      addAccount: 'Add Account',
      sequence: 'No.',
      emailName: 'Email Server Name',
      emailType: 'Email Type',
      emailGroup: 'Email Server Group',
      emailSslEnable: 'SSL',
      emailStatus: 'Server Status',
      accountStatus: 'Account Status',
      senderNickname: 'Sender Nickname',
      senderAccount: 'Sender Account',
      sendCountLimit: 'Max Send Count',
      action: 'Action'
    },
    form: {
      select: 'Please select',
      emailServerPk: 'Server Number',
      emailName: 'Server Name',
      emailType: 'Server Type',
      emailGroup: 'Group',
      emailHost: 'Host',
      emailPort: 'Port',
      emailSslEnable: 'SSL',
      emailStatus: 'Status',
      sendCountLimit: 'Max Send Count',
      accountStatus: 'Account Status',
      emailAccountPk: 'Account Number',
      sendCountUnit: 'Send Unit',
      senderAccount: 'Sender Account',
      senderNickname: 'Sender Nickname',
      senderPassword: 'Sender Password',
      sort: 'Sort',
      remark: 'Remark'
    },
    error: {
      deleteAccount: 'At least one account is required for the server',
      accountStatus: 'Please enter a valid account status',
      emailPort: 'Please enter a valid port',
      emailName: 'Please enter a valid email server name',
      emailGroup: 'Please enter a valid email server group',
      emailHost: 'Please enter a valid host',
      sendCountLimit: 'Please enter a valid max send count',
      emailServerPk: 'Please enter a valid sort number',
      emailSslEnable: 'Please enter a valid SSL status',
      emailStatus: 'Please enter a valid server status',
      emailType: 'Please enter a valid email type',
      sendCountUnit: 'Please enter a valid send unit (D/M)',
      senderAccount: 'Please enter a valid sender account',
      senderNickname: 'Please enter a valid sender nickname',
      senderPassword: 'Please enter a valid sender password',
      remark: 'Please enter a valid remark'
    }
  },
  emailTemplate: {
    BoxWrap: {
      manage: 'Template Query',
      list: 'Template List'
    },
    input: {
      templateName: 'Template Name',
      templateNameHolder: 'Exact Query'
    },
    table: {
      sequence: 'No.',
      templateName: 'Template Name',
      templateContextType: 'Template Type',
      emailTemplateType: 'Group',
      emailTemplatePk: 'Template Number',
      createName: 'Creator',
      createTime: 'Create Time',
      remark: 'Remark',
      action: 'Action'
    },
    form: {
      testSend: 'Test Send',
      inputReciever: 'Receiver Email',
      file: 'Select Template File',
      templateName: 'Template Name',
      emailTemplateType: 'Templete Group',
      templateContextType: 'Template Type',
      templateContext: 'Template Text',
      select: 'Please select',
      emailTemplatePk: 'Template Number',
      sort: 'Sort',
      remark: 'Remark',
      emailConfigId: 'Email Server',
      toAddresses: 'Receiver Email',
      emailTopic: 'Topic',
      emailAccountPk: 'Sender Account',
      emailContent: 'Email Content'
    },
    error: {
      inputReciever: 'Please enter a valid receiver email',
      file: 'Please select a valid file',
      templateName: 'Please enter a valid template name',
      emailTemplateType: 'Please enter a valid group',
      templateContextType: 'Please enter a valid template type',
      templateContext: 'Please enter valid template text',
      emailTemplatePk: 'Please enter a valid template number',
      remark: 'Please enter a valid remark',
      emailConfigId: 'Please enter a valid email server number',
      toAddresses: 'Please enter a valid receiver',
      emailTopic: 'Please enter a valid email subject',
      emailContent: 'Please enter valid email content'
    }
  },
  smsTemplate: {
    BoxWrap: {
      manage: 'Template Manage',
      list: 'Template List'
    },
    table: {
      sequence: 'No.',
      templateName: 'Template Name',
      templateType: 'Template Type',
      templateCode: 'Template Code',
      classification: 'classification',
      isDeleted: 'Status',
      createName: 'Creator',
      createTime: 'Create Time',
      content: 'Template Content',
      action: 'Action'
    },
    form: {
      select: 'Please select',
      testSend: 'Test Send',
      templateName: 'Template Name',
      templateType: 'Template Type',
      templateCode: 'Template Code',
      smsTemplatePk: 'Template Number',
      content: 'Template Content',
      channelId: 'Channel Name',
      channelAccount: 'Channel Account',
      mobile: 'Mobile',
      templateParam: 'Template Parameters'
    },
    error: {
      smsTemplatePk: 'Please enter a valid template number',
      templateName: 'Please select a valid template name',
      templateCode: 'Please enter a valid template code',
      templateType: 'Please enter a valid template type',
      content: 'Please enter valid template content',
      channelId: 'Please enter a valid channel name',
      channelAccount: 'Please enter a valid channel account',
      mobile: 'Please enter a valid mobile number',
      templateParam: 'Please enter valid template parameters'
    }
  },
  smsChannel: {
    BoxWrap: {
      manage: 'Channel Query',
      list: 'Channel List'
    },
    input: {
      channelName: 'Channel Name',
      channelNameHolder: 'Exact query',
      channelCode: 'Channel Code',
      channelCodeHolder: 'Exact query',
      callMethod: 'Call Method',
      callMethodHolder: 'Fuzzy query',
      channelUsage: 'Channel Usage',
      channelUsageHolder: 'Fuzzy query'
    },
    table: {
      sequence: 'No.',
      channelName: 'Channel Name',
      channelCode: 'Channel Code',
      channelAddress: 'Channel Address',
      callMethod: 'Call Method',
      channelUsage: 'Channel Usage',
      isDeleted: 'Status',
      classification: 'Classification',
      createName: 'Creator',
      createTime: 'Create Time',
      action: 'Action',
      paramName: 'Parameter Name',
      paramKey: 'Parameter Key',
      paramValue: 'Parameter Value',
      paramTransport: 'Transport Method',
      smsChannelAccountOwer: 'Account Owner Name',
      accountAppid: 'Account App id',
      accountSecretkey: 'Account Secret Key'
    },
    dropdown: {
      viewParam: 'Channel Parameters',
      viewAccount: 'Channel Accounts'
    },
    form: {
      select: 'Please select',
      channelName: 'Channel Name',
      channelCode: 'Channel Code',
      callMethod: 'Call Method',
      channelUsage: 'Channel Usage',
      smsChannelPk: 'Channel Number',
      remark: 'Remark',
      paramName: 'Parameter Name',
      paramKey: 'Parameter Key',
      paramValue: 'Parameter Value',
      paramTransport: 'Transport Method',
      smsChannelAccountOwer: 'Channel Account Owner',
      accountAppid: 'Account App id',
      accountSecretkey: 'Account Secret Key'
    },
    error: {
      channelName: 'Please enter a valid channel name',
      channelCode: 'Please enter a valid channel code',
      callMethod: 'Please enter a valid call method',
      channelUsage: 'Please enter valid channel usage',
      smsChannelPk: 'Please enter a valid channel number',
      paramName: 'Please enter a valid parameter name',
      paramKey: 'Please enter a valid parameter key',
      paramValue: 'Please enter a valid parameter value',
      paramTransport: 'Please enter a valid transport method',
      smsChannelAccountOwer: 'Please enter a valid channel account owner',
      accountAppid: 'Please enter a valid account App id',
      accountSecretkey: 'Please enter a valid account secret key'
    }
  },
  userClassification: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'User Type List'
    },
    input: {
      clfName: 'Type Name',
      clfNameHolder: 'Fuzzy query',
      clfCode: 'Type Code',
      clfCodeHolder: 'Fuzzy query',
      dpExecutor: 'Executor Name',
      dpExecutorHolder: 'Fuzzy query',
      dpContent: 'Execute Content',
      dpContentHolder: 'Fuzzy query',
      remark: 'Remark',
      remarkHolder: 'Fuzzy query'
    },
    table: {
      sequence: 'No.',
      clfName: 'Type Name',
      clfCode: 'Type Code',
      dpExecutor: 'Executor Name',
      dpContent: 'Execute Content',
      remark: 'Remark',
      createName: 'Creator',
      createTime: 'Create Time',
      lastUpdateTime: 'Update Time',
      action: 'Action'
    },
    form: {
      clfName: 'Type Name',
      clfCode: 'Type Code',
      dpExecutor: 'Executor Name',
      dpContent: 'Execute Content',
      remark: 'Remark'
    },
    error: {
      clfName: 'Type name cannot be empty or exceed 100 chars',
      clfCode: 'Type code cannot be empty or exceed 100 chars',
      dpExecutor: 'Executor name cannot be empty or exceed 100 chars',
      dpContent: 'Execute content cannot be empty',
      remark: 'Remark cannot be empty'
    }
  },
  // new content
  newLoginLog: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Login Log List'
    },
    input: {
      inputHolder: 'Please input',
      loginAccount: 'Login Account',
      loginInStyle: 'Status',
      empNo: 'Employee ID',
      time: 'Login Date',
      timeHolder: 'Select date',
      optionHolder: 'Please select'
    },
    table: {
      systemPk: 'No.',
      logNo: 'Log No.',
      employeeNumber: 'Employee ID',
      loginTerminal: 'Login Terminal',
      username: 'Username',
      loginTime: 'Login Time',
      loginOutTime: 'Logout Time',
      status: 'Status'
    },
    btn: {
      export: 'Export',
      exportText: 'Login Log'
    }
  },
  configuration: {
    common: {
      ENABLED: 'Enabled',
      DISABLED: 'Disabled',
      configurationValue: 'Config Value',
      addValue: 'Add Value'
    },
    BoxWrap: {
      manage: 'Search Query',
      list: 'Config List'
    },
    input: {
      holder: 'Please input',
      fieldCode: 'Field Code',
      directions: 'Instructions',
      configItemName: 'Field Name',
      configurationType: 'Config Type',
      enableStatus: 'Enable Status',
      optionHolder: 'Please select'
    },
    form: {
      code: 'Code',
      fieldCode: 'Field Code',
      configItemName: 'Field Name',
      remark: 'Remark',
      value: 'Value'
    },
    table: {
      systemPk: 'No.',
      fieldCode: 'Field Code',
      configItemName: 'Field Name',
      configurationType: 'Config Type',
      configurationValues: 'Config Value',
      sort: 'Sort',
      enableStatus: 'Enable Status',
      enableTime: 'Enable Time',
      action: 'Action'
    },
    error: {
      configItemName: 'Please enter a valid value',
      itemDetailCode: 'Please enter a valid value',
      itemIsMember: 'Please enter a valid number',
      isNotValueEmpty: 'Value cannot be empty',
      valueCN: 'Please enter a valid value',
      valueEN: 'Please enter a valid value',
      repeat: 'Added value already exists'
    }
  },
  messagePush: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Message Push List'
    },
    common: {
      S: 'Success',
      F: 'Failed',
      resultStatus: {
        STORE_VISIT_FOLLOWED: 'Store Visit To Follow Up',
        STORE_REGISTER: 'New Registered Store',
        ORDER_STATUS_CHANGE: 'Order Status Change'
      },
      batchPush: 'Batch Push'
    },
    input: {
      inputHolder: 'Please input',
      pushContent: 'Push Content',
      pusher: 'Receiver',
      pusherEmail: 'Receiver Email',
      pusherStatus: 'Push Status',
      messageType: 'Message Type',
      time: 'Push Date',
      timeHolder: 'Select date',
      optionHolder: 'Please select'
    },
    table: {
      systemPk: 'No.',
      pusher: 'Receiver',
      pusherPhone: 'Receiver Phone',
      pusherEmail: 'Receiver Email',
      messageType: 'Message Type',
      pushContent: 'Push Content',
      pushStatus: 'Push Status',
      pushDate: 'Push Date',
      action: 'Action',
      rePush: 'RePush'
    },
    message: {
      errorTips: 'Please select message',
      confirmTips: 'rePush?'
    }
  },
  district: {
    BoxWrap: {
      manage: 'Province/City/District Management',
      list: 'Province/City/District List'
    },
    input: {},
    table: {
      province: 'Province',
      city: 'City',
      area: 'District'
    }
  },
  organizationArchitecture: {
    BoxWrap: {
      list: 'Personnel List'
    },
    btn: {
      import: 'Import',
      export: 'Export',
      resetFile: 'Reselect File',
      exportText: 'Business Org. Structure'
    },
    table: {
      sequence: 'No.',
      role: 'Role',
      architectureLevel: 'Hierarchy Level',
      name: 'Name',
      employeeNumber: 'Employee ID',
      type: 'Team Type',
      email: 'Email',
      parentEmpNo: 'Parent Employee No.',
      parentEmpName: 'Parent Employee Name'
    }
  },
  salesArea: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Sales Area List'
    },
    input: {
      iptholder: 'Please enter',
      province: 'Province',
      city: 'City',
      area: 'District',
      empNo: 'Employee ID',
      empName: 'Employee Name',
      email: 'Email',
      cascaderPlaceholder: 'Please select region'
    },
    btn: {
      import: 'Import',
      export: 'Export',
      exportText: 'Sales Area',
      exportRegion: 'Export region',
      exportRegionText: 'Region',
      resetFile: 'Reselect File',
      syncData: 'Update Store SR'
    },
    table: {
      systemPk: 'No.',
      province: 'Province/Municipality',
      city: 'City',
      district: 'District/County',
      empNo: 'Employee ID',
      empName: 'Name'
    },
    message: {
      syncSuccess: 'Sync successful',
      syncFail: 'Sync Failed'
    }
  },
  material: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Product List'
    },
    input: {
      inputHolder: 'Please enter',
      materialCode: 'Product Code',
      materialDescription: 'Product Description',
      materialInnerStatus: 'Offshelf Status',
      brand: 'Brand',
      optionPlaceholder: 'Please select'
    },
    table: {
      materialCode: 'Product Code',
      materialDescription: 'Product Description',
      offshelf: 'Offshelf',
      brand: 'Brand',
      tyreSize: 'Tire Size',
      pattern: 'Pattern',
      ROFType: 'ROF Type',
      action: 'Action'
    }
  },
  serviceProvider: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Supplier List'
    },
    input: {
      inputHolder: 'Please enter',
      serviceProviderCode: 'Supplier Code',
      serviceProviderName: 'Supplier Name',
      serviceProviderNameRegion: 'Supplier Region',
      optionPlaceholder: 'please select'
    },
    table: {
      serviceProviderID: 'Supplier ID',
      serviceProviderName: 'Supplier Name',
      province: 'Province',
      city: 'City',
      district: 'District',
      serviceProviderAddress: 'Supplier Address',
      action: 'Action'
    }
  },
  materialDetails: {
    BoxWrap: {
      manage: 'Product Management'
    },
    header: {
      materialCode: 'Product code'
    },
    form: {
      title: 'Product Master Data',
      materialCode: 'SAP Material Code',
      materialDescription: 'Product Description',
      brand: 'Brand',
      language: 'Language',
      rim: 'Rim Diameter',
      tyreSize: 'Tire Size',
      loadIndex: 'Load Index',
      speedIndex: 'Speed Index',
      pattern: 'Pattern',
      rofType: 'Application Technology',
      oeMark: 'OE Mark',
      sapOffshelf: 'Offshelf Status',
      countryOfOrigin: 'Country of Origin',
      englishPatName: 'Pattern Name (Eng)',
      vehicleType: 'Vehicle Type',
      fitment: 'Typical Fitment'
    }
  },
  salesStatus: {
    BoxWrap: {
      manage: 'Sales management',
      list: 'Sales Status List'
    },
    column: {
      salesTotal: 'Avg. Monthly Total Sales',
      stockTotal: 'Total Stock'
    },
    table: {
      materialDescription: 'Tire Brand',
      tyreSize: 'Main Procurement Channel',
      pattern: 'Payment Terms',
      ROFType: 'Avg. Monthly Sales',
      action: 'Stock'
    }
  },
  doubleWeekPlan: {
    common: {
      selectHolder: 'Please select',
      searchStore: 'Please enter store ID, name or address',
      fillReport: 'Create Report',
      backPlanlist: 'Back to Schedule',
      waitComp: 'To be completed'
    },
    title: {
      storeToVisit: ' Store Visit Task',
      somethingElse: ' an Other Item',
      visitPurpose: 'Visit purpose',
      checkin: 'Check in',
      addStore: 'Add New Store',
      existingMatters: 'Time Conflict',
      checkinSuccess: 'Check in successful',
      checkMap: 'View map',
      storePreview: 'Recommended route for store visiting',
      storeVisitAdvanced: 'Store Visit Plan',
      editDate: 'Edit Date'
    },
    label: {
      conflict: 'Conflict'
    },
    enum: {
      all: 'All',
      plan: 'Plan',
      task: 'Task'
    },
    role: {
      addPlan: 'Add new plan',
      addTask: 'Add new task',
      addStorePlan: 'Store Visit Plan',
      addOtherPlan: 'Non-visit Plan',
      addStoreTask: 'Store Visit Task',
      addOtherTask: 'Non-visit Task',
      editTarget: 'Fill visit purpose',
      matterProcessing: 'Matter processing',
      viewReport: 'View report',
      enote: 'View enote',
      fillReport: 'Enter store visit process',
      checkin: 'Check in',
      otherPlanFirst: 'Please create non-visit plan first',
      newStore: 'Create New Store'
    },
    BoxWrap: {
      manage: 'Search Query',
      list: 'List',
      chooseStore: 'Choose Store'
    },
    step: {
      targetTheme: 'Visit Objective',
      mainTheme: 'Store Selection (Main Objective)',
      otherTheme: 'Store Selection (Other Objective)',
      routePlan: 'Route Planning'
    },
    input: {
      dateRange: 'Date Range',
      startTimeHolder: 'Please select date',
      endTimeHolder: 'Please select date',
      srName: 'SR Name',
      srCode: 'SR ID',
      name: 'Name',
      id: 'ID',
      inputHolder: 'Please enter',
      taskDate: 'Task Date',
      taskType: 'Task Type',
      startTime: 'Start Time',
      endTime: 'End Time',
      customerName: 'Customer Name',
      customerAddress: 'Customer Address',
      desc: 'Description',
      target1: 'Purpose 1',
      target2: 'Purpose 2',
      asmVisitPurpose: 'ASM Visit Purpose',
      asmVisitSummary: 'ASM Visit Summary',
      planDate: 'Visit Date',
      planRangeTime: 'Time Slot',
      TTPSigningVolume: 'Goodyear TPP',
      storeContact: 'Store Contact',
      category: 'Type',
      contactorPhone: 'Collaberative Phone',
      collaborativeFlag: 'Collaberative Visit',
      mainBusiness: 'Main Business',
      storeBrand: 'Store Brand',
      storeStatus: 'Store Status',
      storeType: 'Store Type',
      tppSales: 'TPP Sales',
      monthlySverageSales: 'Monthly Sverage Sales',
      rangeDiameter: 'Range Diameter',
      firstVisitStore: 'First Visit Store',
      endVisitStore: 'End Visit Store',
      businessObjective: 'Business Objective',
      visitTime: 'Visit Time'
    },
    table: {
      date: 'Date',
      status: 'Status',
      startTime: 'Start Time',
      endTime: 'End Time',
      matter: 'Item',
      storeCode: 'Store Code',
      storeName: 'Store Name',
      srName: 'SR Name',
      srCode: 'SR ID',
      action: 'Action',
      PCD: 'Province/City/District',
      storeAddress: 'Address',
      created: 'Created',
      unCreate: 'Empty',
      category: 'Category',
      retailerType: 'Retailer Type',
      rtlRtmCategory: 'RTM Type',
      contact: 'Contact',
      contactor: 'Contactor',
      contactorPhone: 'Tel',
      collaborativeFlag: 'Collaberative Visit',
      mainBusiness: 'Main business',
      storeBrand: 'Sign Board Brand',
      storeStatus: 'Store Status',
      storeType: 'Store Type',
      tppSales: 'TPP',
      monthlySverageSales: 'Avg. Monthly Sales',
      otherInformation: 'Tag',
      rangeDiameter: ' Distance (based on the main objective)',
      firstVisitStore: 'First Visit Store',
      endVisitStore: 'Last Visit Store',
      planRangeNo: 'No.',
      planRangeTime: 'Time Slot',
      backPreviousStep: 'Back',
      rePlanStoreVisits: 'Reschedule',
      confirmCreation: 'Confirm',
      selectMainStore: 'Please select the main theme store',
      selectFirstStore: 'Please select the first visit store',
      moreStoreRecommendations: 'More recommendations',
      moreStoreRecommendationsFirst: 'Currently ',
      moreStoreRecommendationsLast: ' stores have been selected, do you want to continue to add more？',
      backPreviousStepTips: 'Will clear all the stores you have selected. Are you sure?',
      rePlanningTips: 'Will clear all the stores you have selected. Are you sure?'
    },
    btn: {
      export: 'Export',
      exportText: 'Plan Management'
    },
    error: {
      taskType: 'Please select task type',
      storeName: 'Please enter store name',
      PCD: 'Please select province/city/district',
      storeAddress: 'Please enter store address',
      storeChecked: 'Please select store',
      desc: 'Please enter brief description',
      visitPurpose: 'Please select visit purpose',
      planDate: 'Please select plan date',
      planRangeTime: 'Please fill visit time',
      taskTarget: 'Please fill visit purpose info',
      visitTime: 'Please select time'
    }
  },
  SRStoreList: {
    common: {
      addStore: 'Add New Store',
      selectHolder: 'Please select',
      startTimeHolder: 'Start time',
      endTimeHolder: 'End time',
      startMonthHolder: 'Start Month',
      endMonthHolder: 'End Month',
      cascaderPlaceholder: 'Please select region',
      pleaseSelectMonth: 'Please select month'
    },
    export: {
      storeInfo: 'Store Basic Info',
      otherInfo: 'Sales Situation',
      trainRecord: 'Training Records',
      visitRecord: 'Visit Records',
      KPIData: 'Other Reference Info',
      storeLogoInfo: 'Signboard Related Info',
      feedback: '意向反馈情况en'
    },
    BoxWrap: {
      manage: 'Search Query',
      list: 'Store List'
    },
    btn: {
      import: 'Import',
      export: 'Export',
      resetFile: 'Reselect File'
    },
    form: {
      customerNumber: 'Store ID',
      storeName: 'Store Name',
      RTMType: 'RTM Type',
      retailStoreCategory: 'Retailer Type',
      provinceCityDistrict: 'Province/City/District',
      province: 'Province',
      city: 'City',
      area: 'District',
      address: 'Address',
      SRNO: 'SR ID',
      SRName: 'SR Name',
      storeContact: 'Store Contact',
      lastPurchaseTime: 'Latest RTM Order Time',
      TTPSigningVolumeGY: 'Goodyear TPP',
      TTPSigningVolumeCP: 'Cooper TPP',
      lastVisitTime: 'Last Visit Date',
      shopBrandType: 'Signboard Brand',
      visitFrequency: 'Visits Frequency',
      rebateBalance: 'Rebate Balance',
      isBaiLian: 'Bailian Converted',
      monthRange: 'Month',
      visitTheme: 'Visit Theme'
    },
    table: {
      customerNumber: 'Store ID',
      storeName: 'Store Name',
      RTMType: 'RTM Type',
      retailStoreCategory: 'Retailer Type',
      province: 'Province',
      city: 'City',
      area: 'District',
      address: 'Address',
      SRNO: 'SR ID',
      SRName: 'SR Name',
      TTPSigningVolumeGY: 'Goodyear TPP',
      TTPSigningVolumeCP: 'Cooper TPP',
      rebateBalance: 'Rebate Balance',
      lastPurchaseTime: 'Latest RTM order time',
      lastVisitTime: 'Last Visit Date',
      visitFrequency: 'Visits frequency',
      contract: 'TMall/JD Participation',
      shopBrandType: 'Signboard Brand',
      gasnFlag: 'GASN Sign',
      pointBalance: 'Point Balance',
      storeContact: 'Contact',
      action: 'Action'
    }
  },
  CPStoreList: {
    common: {
      addStore: 'Add New Store',
      selectHolder: 'Please select',
      startTimeHolder: 'Start time',
      endTimeHolder: 'End time',
      startMonthHolder: 'Start Month',
      endMonthHolder: 'End Month',
      cascaderPlaceholder: 'Please select region',
      pleaseSelectMonth: 'Please select month'
    },
    export: {
      storeInfo: 'Store Info',
      visitReport: 'Visit Report'
    },
    BoxWrap: {
      manage: 'Search Query',
      list: 'Store List'
    },
    btn: {
      import: 'Import',
      export: 'Export',
      resetFile: 'Reselect File'
    },
    form: {
      customerNumber: 'Store ID',
      storeName: 'Store Name',
      RTMType: 'RTM Type',
      retailStoreCategory: 'Retailer Type',
      provinceCityDistrict: 'Province/City/District',
      province: 'Province',
      city: 'City',
      area: 'District',
      address: 'Address',
      SRNO: 'SR ID',
      SRName: 'SR Name',
      storeContact: 'Store Contact',
      lastPurchaseTime: 'Latest RTM Order Time',
      TTPSigningVolumeGY: 'Goodyear TPP',
      TTPSigningVolumeCP: 'Cooper TPP',
      lastVisitTime: 'Last Visit Date',
      shopBrandType: 'Signboard Brand',
      visitFrequency: 'Visits Frequency',
      rebateBalance: 'Rebate Balance',
      isBaiLian: 'Bailian Converted',
      monthRange: 'Month',
      visitTheme: 'Visit Theme'
    },
    table: {
      customerNumber: 'Store ID',
      storeName: 'Store Name',
      RTMType: 'RTM Type',
      retailStoreCategory: 'Retailer Type',
      province: 'Province',
      city: 'City',
      area: 'District',
      address: 'Address',
      SRNO: 'SR ID',
      SRName: 'SR Name',
      TTPSigningVolumeGY: 'Goodyear TPP',
      TTPSigningVolumeCP: 'Cooper TPP',
      rebateBalance: 'Rebate Balance',
      lastPurchaseTime: 'Latest RTM order time',
      lastVisitTime: 'Last Visit Date',
      visitFrequency: 'Visits frequency',
      contract: 'TMall/JD Participation',
      shopBrandType: 'Signboard Brand',
      gasnFlag: 'GASN Sign',
      pointBalance: 'Point Balance',
      storeContact: 'Contact',
      action: 'Action'
    }
  },
  DAStoreList: {
    common: {
      selectHolder: 'Please select',
      exportText: 'Retailor and SR Relationship'
    },
    BoxWrap: {
      manage: 'Search Query',
      list: 'Retailor & SR Relationship List'
    },
    form: {
      customerNumber: 'Store ID',
      storeName: 'Store Name',
      RTMType: 'RTM Type',
      retailStoreCategory: 'Retailer Type',
      provinceCityDistrict: 'Province/City/District',
      province: 'Province',
      city: 'City',
      area: 'District',
      address: 'Address',
      SRNO: 'SR ID',
      SRName: 'SR Name',
      spFullName: 'Service Provider/Distributor',
      cascaderPlaceholder: 'Please select region'
    },
    table: {
      sequence: 'No.',
      customerNumber: 'Store ID',
      storeName: 'Store Name',
      RTMType: 'RTM Type',
      retailStoreCategory: 'Retailer Type',
      province: 'Province',
      city: 'City',
      area: 'District',
      address: 'Address',
      SRNO: 'SR ID',
      SRName: 'SR Name',
      spFullName: 'SP/Distributor',
      remarkOne: 'Category 1',
      remarkTwo: 'Category 2',
      remarkThree: 'Category 3',
      action: 'Action'
    }
  },
  storeVisitReport: {
    common: {
      project: 'Project',
      point: 'Percentage',
      basicInfo: 'Basic Info',
      moreInfo: 'Additional Info',
      RSSAS: 'Retailer Profile',
      storeSInfo: 'Signboard Information With Photo(s)',
      storeMS: 'Store Service Item',
      facAEq: 'Facilities & Equipment',
      otherMsg: 'Other Reference Info',
      uploadPhotoTip: 'Only jpg/png under 500kb allowed',
      saveReportSuccess: 'Report saved, returning to list',
      submitTip: 'Are you sure? Notice: Submitted report cannot be modified',
      submit: 'Submit',
      disSubmit: 'Do Not Submit'
    },
    step: {
      RSInfo: 'Retailer Info',
      sales: 'Sales Overview',
      TPPRecords: 'TPP Record',
      salesRecord: 'Retailer KPI',
      trainingRecord: 'Training Record',
      visitorRecord: 'Visiting Record'
    },
    basic: {
      retailStoreRTMCategory: 'RTM Type',
      retailStoreCategory: 'Retail Store Category',
      retailStoreCategoryDesc: 'Retail Store Category Description',
      customerNumber: 'Store ID',
      storeName: 'Store Name',
      address: 'Address',
      provinceCityDistrict: 'Province/City/District',
      province: 'Province',
      city: 'City',
      area: 'District',
      telPhone: 'Phone',
      contact1: 'Contact 1',
      cellPhone1: 'Mobile 1'
    },
    more: {
      contact2: 'Contact 2',
      cellPhone2: 'Mobile 2',
      contact3: 'Contact 3',
      cellPhone3: 'Mobile 3',
      customerCreationDate: 'Created Date',
      empNo: 'SR ID',
      empName: 'SR Name',
      category1: 'Category 1',
      category2: 'Category 2',
      category3: 'Category 3',
      serviceProvider: 'Service Provider/Distributor'
    },
    RSSAS: {
      carTRHistory: 'Years in Consumer Tire Business',
      carTAForTotal: 'Consumer Tire SOB',
      AvMSalesOfTires: 'Avg. Monthly Total Tire Sales',
      RSS: 'Retail Store Structure',
      employeeCount: 'No. of Employees',
      retailShare: '% of retail business',
      maxSalesBrand: 'Top selling brand',
      maxSalesQty: 'Largest brand monthly sales',
      gySalesQty: 'Goodyear monthly sales'
    },
    storeSInfo: {
      shopSignBrand: 'Signboard Brand',
      otherBrands: 'Other Brands',
      installationDate: 'Installation Date',
      expiryDate: 'Expiry Date',
      employeeCount: 'No. of Employees',
      storefrontPic: 'Signboard Photo',
      displayPic1: 'Display Photo 1',
      displayPic2: 'Display Photo 2',
      siMain: 'Main Services',
      siMainPercentage: 'Main Services as % of Revenue'
    },
    storeMS: {
      tire: 'Tires',
      nonTire: 'Non-tire',
      maintainance: 'Car Service',
      quickFix: 'Repair',
      cosmetic: 'Beauty',
      washCar: 'Car Wash',
      otherService: 'Other Services',
      siBalance: 'Balance',
      siWheelPosition: 'Wheel Position',
      siTireRepair: 'Tire Repair',
      siValve: 'Valve',
      siEngineOil: 'Engine Oil',
      siBrake: 'Brake',
      siBattery: 'Battery',
      siFacialClean: 'Facial Clean',
      siPerishableGoods: 'Perishable Goods'
    },
    facAEq: {
      area: 'Store Area',
      stationsCount: 'Work Bays',
      accountingMethod: 'Accounting Method',
      instoreFac: 'In-store Facilities',
      toilet: 'Wash Room',
      customerLounge: 'Customer Lounge',
      wheelAlignment: 'Alignment',
      tireMachine: 'Fitting',
      DBMachine: 'Balancing',
      liftMachine: 'Lifting'
    },
    otherMsg: {
      pointBalance: 'GBDF Point Balance',
      rebateBalance: 'Rebate Balance',
      visitFrequency: 'Visit Record This Month?',
      contract: 'TMall/JD Participation',
      contractTM: 'TMall Participation',
      contractJD: 'JD Participation',
      lastVisitTime: 'Latest Visit Date',
      lastPurchaseTime: 'Latest RTM Order Date'
    },
    SSTable: {
      tireBrand: 'Tire Brand',
      mainChannel: 'Main Procurement Channel',
      payway: 'Payment Terms',
      AMSales: 'Avg. Monthly Sales',
      stock: 'Stock',
      sum: 'Sum',
      storeMIX: 'Store 18+MIX',
      updateTime: 'Update Time',
      msg1: '请至少填写一项en'
    },
    SStatistic: {
      AvMSalesOfTires: 'Avg. Monthly Total Tire Sales',
      stockTotal: 'Total Stock',
      updateTime: 'Update Date'
    },
    TPPRCommon: {
      changeLog: 'Change History',
      TPPInfo: 'TPP Signed Qty'
    },
    // TPPRTable: {
    //   contractStatus: 'Contract Status',
    //   RTMTypeold: 'RTM Type old',
    //   RTMTypenew: 'RTM Type new',
    //   RetailerTypeold: 'Retailer Type old',
    //   RetailerTypenew: 'Retailer Type new',
    //   GYTPPvolumeold: 'GY TPP volume old',
    //   year: 'Year',
    //   brand: 'Brand',
    //   January: 'Jan',
    //   February: 'Feb',
    //   March: 'Mar',
    //   April: 'Apr',
    //   May: 'May',
    //   June: 'Jun',
    //   July: 'Jul',
    //   August: 'Aug',
    //   September: 'Sep',
    //   October: 'Oct',
    //   November: 'Nov',
    //   December: 'Dec'
    // },
    SRecord: {
      monthly: 'Month',
      quarter: 'Quarter',
      year: 'Year'
    },
    TRForm: {
      TRContent: 'Training Content',
      TRDate: 'Training Date',
      TRWay: 'Training Method',
      TRAddress: ' Training Venue',
      trainer: 'Trainer',
      trainee: 'Trainee',
      GYTComments: 'Goodyear Trainer Comments',
      effAchieved: 'Training Results',
      nexTPlan: 'Next Session'
    },
    VRForm: {
      VRDate: 'Date',
      participants: 'Participants',
      startTime: 'Start Time',
      endTime: 'End Time',
      destination1: 'Purpose 1',
      destination2: 'Purpose 2',
      issue1: 'Topic 1',
      detailDesc1: 'Detail Description 1',
      issue2: 'Topic 2',
      detailDesc2: 'Detail Description 2',
      issue3: 'Topic 3',
      detailDesc3: 'Detail Description 3',
      issue4: 'Topic 4',
      detailDesc4: 'Detail Description 4',
      followMatter1: 'Follow-up 1',
      followDeadline1: 'Follow-up Deadline 1',
      followMatter2: 'Follow-up 2',
      followDeadline2: 'Follow-up Deadline 2',
      followMatter3: 'Follow-up 3',
      followDeadline3: 'Follow-up Deadline 3',
      photoFile: 'Attach photos',
      others: 'Checklist',
      feedback: 'Feedback',
      feedback_other_task: 'Task Desc'
    },
    recordFeedback: {
      subTitle1: '合作意向反馈_en',
      subTitle2: '门店意见反馈_en',
      acceptTerms: '是否必须要有账期才会合作_en',
      willingToRtmOrder: '是否愿意下载飞足e购APP来订购固特异轮胎_en',
      urgentDeliveryTime: '紧急订单期望物流时效_en',
      regularDeliveryTime: '常规订单期望物流时效_en',
      evaluateRate: '门店潜力评分_en',
      goodContent: '正面评价_en',
      badContent: '反面评价_en',
      otherContent: '其他评价_en'
    },
    errMsg: {
      photos: 'Please fill in all the mandatory fields',
      checkList: 'Please fill in all the mandatory fields',
      evaluateRate: '请给门店的潜力评分_en',
      contentList: '请至少选择或输入一项评价_en',
      otherContentList: '请输入其他评价的内容_en',
      otherTaskDescription: 'Please fill in all the mandatory fields'
    }
  },
  retailStoresInfo: {
    common: {
      back: 'Back'
    },
    title: {
      storeName: 'Store Name'
    },
    input: {
      inputHolder: 'Please input',
      dataHolder: 'Please select date',
      selectHolder: 'Please select'
    },
    error: {
      validPhone: 'Please enter valid phone number',
      name: 'Please enter valid name',
      float: 'Please enter valid numberic',
      patt: 'Please enter a valid numerical value, 2 decimal percents supported',
      stringLength: 'Please enter a valid value',
      sn: 'Please enter a valid numberic'
    },
    form: {
      baseInfo: {
        title: 'Basic Info',
        customerCode: 'Store ID',
        storeName: 'Store Name',
        retailerRTMCategory: 'RTM Type',
        retailerCategory: 'Retailor Store Category',
        retailerCategoryDescription: 'Retailor Store Category Description',
        province: 'Province',
        city: 'City',
        district: 'District',
        address: 'Address',
        contacts1: 'Contact 1',
        mobile: 'Mobile 1',
        visitFrequency: 'Visits This Month',
        pointBalance: 'Point Balance',
        rebateBalance: 'Rebate Balance',
        lastPurchaseTime: 'Last RTM Order Time',
        lastStartTime: 'Last Visit Time'
      },
      moreInfo: {
        title: 'Additional Info',
        contact2: 'Contact 2',
        mobile2: 'Mobile 2',
        contact3: 'Contact 3',
        mobile3: 'Mobile 3',
        customerCreationTime: 'Created Date',
        empNo: 'SR ID',
        empName: 'SR Name',
        serviceProvince: 'Service Provider/Distributor',
        remark1: 'Category 1',
        remark2: 'Category 2',
        remark3: 'Category 3'
      },
      storeArchSit: {
        title: 'Retailer Profile',
        experienceYear: 'Years in Consumer Tire Business',
        businessVolume: 'Consumer Tire SOB',
        monSalesVolume: 'Avg. Monthly Total Tire Sales',
        retailStoreStructure: 'Retail Store Structure',
        emNum: 'No. of Employees',
        retailShare: 'Retail Share',
        maxSalesBrand: 'Max Sales Brand',
        maxSalesQty: 'Max Sales Qty',
        gySalesQty: 'GY Sales Qty'
      },
      storeInfoPic: {
        title: 'Signboard Information With Photo(s)',
        storeSignBrand: 'Signboard Brand',
        otherBrands: 'Other Brands',
        installationDate: 'Installation Date',
        expDate: 'Expiry Date',
        storefrontPic: 'Signboard Photo',
        displayPic1: 'Display Photo 1',
        displayPic2: 'Display Photo 2'
      },
      mainServicesInStore: {
        title: 'Store Service Item',
        serviceItem: 'Project',
        otherItem: 'Other Service',
        mainItem: 'Main Service',
        busVolume: 'Main Services as % of Revenue'
      },
      storeFacEqu: {
        tire: 'Tires',
        nonTire: 'Non-tire',
        title: 'Facilities & Equipment',
        storeArea: 'Store Area',
        worksNum: 'Work Bays',
        accountMethod: 'Accounting Method',
        storeFac: 'In-store Facilities',
        siTire: 'Tires',
        siMaintainence: 'Car Service',
        siFastRepair: 'Repair',
        siBeauty: 'Beauty',
        siWashing: 'Car Wash',
        siBalance: 'Balance',
        siWheelPosition: 'Wheel Position',
        siTireRepair: 'Tire Repair',
        siValve: 'Valve',
        siEngineOil: 'Engine Oil',
        siBrake: 'Brake',
        siBattery: 'Battery',
        siFacialClean: 'Facial Clean',
        siPerishableGoods: 'Perishable Goods',
        laundry: 'Wash Room',
        restRoom: 'Customer Lounge',
        alignment: 'Alignment',
        fitting: 'Fitting',
        balancing: 'Balancing'
      },
      otherBrandSales: {
        systemPk: 'No.',
        title: 'Sales',
        brand: 'Tire Brand',
        tireSupplier: 'Main Procurement Channel',
        paymentTerms: 'Payment Terms',
        monthlyAvgSales: 'Avg. Monthly Sales',
        stock: 'Stock',
        tyreEighteenGreater: 'Store 18+MIX',
        updateTime: 'Update Time'
      },
      ttpSignAesc: {
        systemPk: 'No.',
        title: 'TPP Records',
        signingStatus: 'Signing Status',
        RTMOldType: 'RTM Type Old',
        RTMNewType: 'RTM Type New',
        stoOldType: 'Retailer Type Old',
        stoNewType: 'Retailer Type New',
        GYOldSign: 'GY TPP Volume Old',
        GYNewSign: 'GY TPP Volume New',
        CPOldSign: 'CP TPP Volume Old',
        CPNewSign: 'CP TPP Volume New',
        effectiveDate: 'Effective Date',
        createTime: 'Create Date',
        updateTime: 'Update Date'
      },
      model: {
        salesKPI: 'Store Sales KPI',
        visitStoRecord: 'Store Visit Records',
        trainRecord: 'Training Records'
      },
      otherRecord: {
        title: 'Other Reference Info',
        pointBalance: 'GBDF Point Balance',
        rebateBalance: 'Rebate Balance',
        visitFrequency: 'Visit Record This Month?',
        contract: 'TMall/JD Participation',
        contractTM: 'TMall Participation',
        contractJD: 'JD Participation',
        lastVisitTime: 'Lastest Visit Date',
        lastPurchaseTime: 'Lastest RTM Order Date'
      },
      product: {
        common: {
          title: 'Product info'
        },
        input: {
          vehicleType: 'Vehicle Type',
          rimSize: 'Rim Size',
          pattern: 'Pattern',
          specification: 'Tire Size'
        },
        table: {
          productCode: 'Product Code',
          productName: 'Product Name',
          isLongTailProduct: 'Is Longtail Product',
          rimSize: 'Rim Size',
          productPrice: 'List Price(Incl. Tax)',
          productPriceTax: 'Order Price(Incl. Tax)',
          regularProductStockAllowance: 'Regular Product Stock Allowance',
          longTailProductStock: 'Longtail Product Stock'
        },
        error: {
          specification: 'Please input more than 5 characters in specification query'
        }
      },
      year: {
        brand: 'Brand',
        january: 'Jan',
        february: 'Feb',
        march: 'Mar',
        april: 'Apr',
        may: 'May',
        june: 'Jun',
        july: 'Jul',
        august: 'Aug',
        september: 'Sep',
        october: 'Oct',
        november: 'Nov',
        december: 'Dec'
      }
    }
  },
  visitRecord: {
    title: {
      text: 'Checklist'
    },
    table: {
      systemPk: 'No.',
      date: 'Date',
      startTime: 'Start Time',
      endTime: 'End Time',
      visitPurpose1: 'Visit Purpose 1',
      visitPurpose2: 'Visit Purpose 2',
      participant: 'Participants',
      topics1: 'Topic 1',
      desDetailed1: 'Detail Description 1',
      topics2: 'Topic 2',
      desDetailed2: 'Detail Description 2',
      topics3: 'Topic 3',
      desDetailed3: 'Detail Description 3',
      topics4: 'Topic 4',
      desDetailed4: 'Detail Description 4',
      followUpMatters1: 'Follow-up Matter 1',
      followUpDeadline1: 'Follow-up Deadline 1',
      followUpMatters2: 'Follow-up Matter 2',
      followUpDeadline2: 'Follow-up Deadline 2',
      followUpMatters3: 'Follow-up Matter 3',
      followUpDeadline3: 'Follow-up Deadline 3',
      comBusPol: 'Communicate Business Policy',
      priceAnalysisCom: 'Price Analysis Comparison',
      isOrderCom: 'Order Recommendation & Acquisition',
      isTrain: 'Training',
      isStockCheck: 'Stock Check',
      isFeizuEPurchase: 'RTM purchase',
      isGetBusPol: 'Obtain Business Policy & Market Info',
      isPushQuestionnaire: 'Fill Periodic Questionnaire',
      action: 'Photos/Files'
    }
  },
  enote: {
    title: {
      enote: 'ENOTE'
    },
    content: {
      noData: 'No data'
    }
  },
  trainingRecords: {
    table: {
      systemPk: 'No.',
      trainingCourse: 'Training Content',
      trainingDate: 'Training Date',
      trainingLocation: 'Training Venue',
      trainer: 'Trainer',
      trainee: 'Trainee',
      trainingChannel: 'Training Method',
      gyTrainerComments: 'Goodyear Trainer Comments',
      trainingAchievement: 'Training Results',
      nextTrainingPlan: 'Next Training Plan'
    }
  },
  salesKPIManagement: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Sales KPI List'
    },
    common: {
      exportText: 'Sales KPI Management'
    },
    form: {
      rsmEmpNo: 'Region Head ID',
      rsmEmpName: 'Region Head Name',
      asmEmpNo: 'ASM ID',
      asmEmpName: 'ASM Name',
      empNo: 'SR ID',
      empName: 'SR Name',
      brand: 'Brand',
      year: 'Year'
    },
    table: {
      rsmEmpNo: 'Region Head ID',
      rsmEmpName: 'Region Head Name',
      asmEmpNo: 'ASM ID',
      asmEmpName: 'ASM Name',
      empNo: 'SR ID',
      empName: 'SR Name',
      brand: 'Brand',
      year: 'Year',
      JanuaryTargetSales: 'Jan Target Sales',
      January17TargetSales: 'Jan 17+ Target Sales',
      January18TargetSales: 'Jan 18+ Target Sales',
      FebruaryTargetSales: 'Feb Target Sales',
      February17TargetSales: 'Feb 17+ Target Sales',
      February18TargetSales: 'Feb 18+ Target Sales',
      MarchTargetSales: 'Mar Target Sales',
      March17TargetSales: 'Mar 17+ Target Sales',
      March18TargetSales: 'Mar 18+ Target Sales',
      AprilTargetSales: 'Apr Target Sales',
      April17TargetSales: 'Apr 17+ Target Sales',
      April18TargetSales: 'Apr 18+ Target Sales',
      MayTargetSales: 'May Target Sales',
      May17TargetSales: 'May 17+ Target Sales',
      May18TargetSales: 'May 18+ Target Sales',
      JuneTargetSales: 'Jun Target Sales',
      June17TargetSales: 'Jun 17+ Target Sales',
      June18TargetSales: 'Jun 18+ Target Sales',
      JulyTargetSales: 'Jul Target Sales',
      July17TargetSales: 'Jul 17+ Target Sales',
      July18TargetSales: 'Jul 18+ Target Sales',
      AugustTargetSales: 'Aug Target Sales',
      August17TargetSales: 'Aug 17+ Target Sales',
      August18TargetSales: 'Aug 18+ Target Sales',
      SeptemberTargetSales: 'Sep Target Sales',
      September17TargetSales: 'Sep 17+ Target Sales',
      September18TargetSales: 'Sep 18+ Target Sales',
      OctoberTargetSales: 'Oct Target Sales',
      October17TargetSales: 'Oct 17+ Target Sales',
      October18TargetSales: 'Oct 18+ Target Sales',
      NovemberTargetSales: 'Nov Target Sales',
      November17TargetSales: 'Nov 17+ Target Sales',
      November18TargetSales: 'Nov 18+ Target Sales',
      DecemberTargetSales: 'Dec Target Sales',
      December17TargetSales: 'Dec 17+ Target Sales',
      December18TargetSales: 'Dec 18+ Target Sales'
    }
  },
  contractKPIManagement: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Contract KPI List'
    },
    common: {
      exportText: 'Contract KPI Management'
    },
    form: {
      rsmEmpNo: 'Region Head ID',
      rsmEmpName: 'Region Head Name',
      asmEmpNo: 'ASM ID',
      asmEmpName: 'ASM Name',
      empNo: 'SR ID',
      empName: 'SR Name',
      year: 'Year'
    },
    table: {
      rsmEmpNo: 'Region Head ID',
      rsmEmpName: 'Region Head Name',
      asmEmpNo: 'ASM ID',
      asmEmpName: 'ASM Name',
      empNo: 'SR ID',
      empName: 'SR Name',
      year: 'Year',
      oneSigningTargetQty: 'Jan Signing Target',
      oneActiveTargetQty: 'Jan Active Stores Target',
      twoSigningTargetQty: 'Feb Signing Target',
      twoActiveTargetQty: 'Feb Active Stores Target',
      threeSigningTargetQty: 'Mar Signing Target',
      threeActiveTargetQty: 'Mar Active Stores Target',
      fourSigningTargetQty: 'Apr Signing Target',
      fourActiveTargetQty: 'Apr Active Stores Target',
      fiveSigningTargetQty: 'May Signing Target',
      fiveActiveTargetQty: 'May Active Stores Target',
      sixSigningTargetQty: 'Jun Signing Target',
      sixActiveTargetQty: 'Jun Active Stores Target',
      sevenSigningTargetQty: 'Jul Signing Target',
      sevenActiveTargetQty: 'Jul Active Stores Target',
      eightSigningTargetQty: 'Aug Signing Target',
      eightActiveTargetQty: 'Aug Active Stores Target',
      nineSigningTargetQty: 'Sep Signing Target',
      nineActiveTargetQty: 'Sep Active Stores Target',
      tenSigningTargetQty: 'Oct Signing Target',
      tenActiveTargetQty: 'Oct Active Stores Target',
      elevenSigningTargetQty: 'Nov Signing Target',
      elevenActiveTargetQty: 'Nov Active Stores Target',
      twelveSigningTargetQty: 'Dec Signing Target',
      twelveActiveTargetQty: 'Dec Active Stores Target'
    }
  },
  storeComponents: {
    common: {
      pleaseSelectMonth: 'Please select month',
      pleaseSelectQuarter: 'Please select/input quarter',
      pleaseSelectYear: 'Please select year',
      targetSalesMonth: 'Sales Target',
      numberOfOrders: 'SP Confirmed',
      numberOfConfirmations: 'Retailer Confirmed',
      desc1: 'Historical months: full month data; Current month: month-to-date data till yesterday',
      desc2: 'Historical quarter: full quarter data; Current quarter: quarter-to-date data till yesterday',
      desc3: 'Historical year: full year data; Current year: year-to-date data till yesterday',
      comment: 'Comment',
      task: 'Assign tasks'
    },
    title: {
      sales: 'Sales',
      saleDisplay: 'PERFORMANCE',
      store: 'STORES',
      order: 'ORDERS',
      visitReport: 'VISIT REPORTS',
      visitReportTitle: 'Visit Reports/Visit Days',
      TPP: 'TPP Attainment',
      monthlyActualSales: 'Monthly Actual Sales',
      quarterActualSales: 'Quarterly Actual Sales',
      orderStatus: 'Order Status',
      tppRate: 'Attainment',
      tppCount: 'Sales',
      tppUnfinishCount: 'Gap',
      finishRate: 'Attainment',
      totalSales: 'Sales',
      unfinishSales: 'Gap',
      GY: 'Goodyear',
      CP: 'Cooper',
      tppSignNum: 'TPP Signed Stores(Monthly)',
      tppActiveNum: 'Active TPP Stores(Monthly)',
      tppActiveNumQuarter: 'Active Stores(Quarterly)',
      item1: '',
      item2: '',
      item3: '',
      shop: 'STORES'
    },
    table: {
      col1: 'MIX',
      col2: 'Target',
      col3: 'Sales/Gap',
      col4: 'Attainment',
      row1: 'Total'
    },
    tab: {
      month: 'Monthly',
      quarter: 'Quarterly',
      year: 'Yearly',
      sales: 'PCS',
      money: 'Revenue',
      score: 'Score',
      store: 'Store'
    },
    select: {
      brand: 'Select Brand',
      month: 'Select Month',
      quarter: 'Select Quarter',
      year: 'Select Year'
    },
    form: {
      brand: 'Brand',
      month: 'Monthly',
      quarter: 'Quarterly',
      year: 'Yearly'
    },
    charts: {
      total: 'Total'
    }
  },
  taskScheduleLog: {
    BoxWrap: {
      manage: 'Search Query',
      list: 'Task Schedule Log List'
    },
    input: {
      taskJobName: 'Task Job Name',
      taskSchedulerJobPk: 'Task Scheduler Job Pk',
      result: 'Result',
      time: 'Time Range',
      inputHolder: 'Please input',
      dataHolder: 'Please select date',
      selectHolder: 'Please select'
    },
    table: {
      sequence: 'No.',
      taskSchedulerJobPk: 'Task Scheduler Job Pk',
      taskJobName: 'Task Job Name',
      result: 'Result',
      errorMsg: 'Error Msg',
      executeSec: 'Execute Sec(ms)',
      createTime: 'Create Time',
      lastUpdateTime: 'Last Update Time',
      action: 'Action'
    },
    message: {
      success: 'execute success',
      error: 'execute error'
    }
  },
  dashboard: {
    GY: 'GY',
    CP: 'CP',
    achievementRate: 'ATTAINMENT',
    underachievedQuat: 'GAP',
    ECharts_actual: 'ACTUAL',
    newProduct: 'PCS OF NEW PRODUCTS',
    activeStoreTarget: 'ACTIVE / TARGET',
    signStoreTarget: 'TPP SIGNED STORES / TARGET',
    sortNum: 'No.',
    salesNumber: 'ACTUAL',
    spName: 'SP',
    monthRegistered: 'MONTHLY REGISTERED',
    annuallyRegistered: 'ANNUALLY REGISTERED',
    allRegistered: 'TOTAL REGISTERED',
    timeVar: 'Time',
    integral: 'Score',
    revenueAmount: 'REVENUE',
    revenueAverage: 'AVERAGE PRICE',
    integralTarget: 'REVENUE',
    integralTarget2: 'Score Target',
    revenueTarget: 'REVENUE TARGET',
    revenueTarget2: 'TARGET',
    revenuePreTire: 'REVENUE PER TIRE',
    grossMargin: 'GROSS MARGIN',
    grossMarginTarget: 'GROSS MARGIN TARGET',
    grossMarginPreTire: 'GROSS MARGIN PER TIRE',
    revenueTip: 'All revenue related data are exclusive of tax, of which the rebate amount is estimated and for reference only, the actual data is subject to financial settlement.',
    storeTip: 'ACTIVE: Exisits confirmed orders on the current month.',
    storeAllTip: 'ACTIVE: Exisits confirmed orders both the current and previous month.',
    bonus: {
      title: 'Quartly Incentive Estimation',
      button: 'Calc',
      salary: 'Monthly Salary',
      bonus: 'Bonus',
      bonusMonth: 'Monthly Bonus',
      tip: 'The above calculation only takes into account the sales points portion and does not include the points for building stores. The numbers are for reference only, and the final bonus amount is subject to the calculation by the personnel department.'
    },
    filter: {
      specification: 'Specification',
      specificationPlaceHolder: 'Input Tire',
      sp: 'SP',
      spPlaceHolder: 'Enter the service provider name',
      asm: 'ASM',
      asmPlaceHolder: 'Enter ASM name',
      sr: 'SR',
      srPlaceHolder: 'Enter SR name'
    },
    commentSuccess: 'Your like or comments have been sent',
    excellent: 'Excellent',
    goodJob: 'Good Job!',
    perfect: 'Perfect',
    pleaseSelect: 'Please Select',
    asrSort: 'ASM Ranking',
    srSort: 'SR Ranking',
    spSort: 'SP Ranking',
    commentInfo: 'How well did selected associates perform?',
    commentInfoConfirm: 'Are you sure you want to deselect',
    hasChoose: 'You have selected ',
    mix: 'PCS OF MIX',
    target: 'PCS OF TARGET SEGMENT',
    pleaseComment: 'Please leave comments',
    order: 'ORDERS',
    orderTarget_confirmedQty: 'Retailer Confirmed',
    commentDialogTitle: 'COMMENT',
    saleDisplayForTab: 'Performance',
    comment_hintText: 'Anything to add?',
    spBatchCommentDesc: 'How well did these {quat} service providers perform?',
    asmBatchCommentDesc: 'How well did these {quat} ASMs perform?',
    srBatchCommentDesc: 'How well did these {quat} SRs perform?',
    salesReport: 'Sales Report'
  },
  // 任务分配
  assignTasks: {
    DialogTitle: 'Assign Tasks',
    SR: 'SR',
    taskFromType: 'Task Source',
    taskType: 'Task Type',
    rtlRtmCategory: 'RTM Type',
    retailerType: 'Retailer Type',
    storeAddress: 'Address',
    retailorStore: 'Select Store',
    createName: 'Assignor',
    nowTime: 'Task Allocation Time',
    signBoardBidFlag: 'Sign Board Bid',
    visitPurpose: 'Visit Purpose',
    dueTime: 'Deadline',
    remark: 'Remark',
    sendSuccess: 'Send Success',
    selectStore: 'Please Select Store',
    table: {
      storeCode: 'Store Code',
      storeName: 'Store Name',
      storeAddress: 'Store Address',
      contactor: 'Contactor'
    }
  },
  Chatbot: {
    Chatbot: 'Chatbot ',
    Chatbot_knowledge_base: 'Knowledge Base ',
    Chatbot_behavior_analysis: 'Visit Analysis ',
    copy_success: 'Copy Success ',
    copy_failed: 'Copy Failed ',
    chatbot_feedback: 'Thanks for your feedback! ',
    chatbot_dialog: 'Dialog ',
    chatbot_rebuild_failed: 'Rebuild Failed ',
    Chatbot_input_placeholder: 'Please enter the question',
    Chatbot_tips: 'Hi! You may ask '
  },
  salesReport: {
    BoxWrap: {
      manage: 'Sales Detail Report',
      list: 'Sales Detail Report'
    },
    common: {
      exportText: 'Sales Detail Report',
      submitSuccess: 'Submit Successful',
      submitFail: 'Submit Fail',
      success: 'Operation Successful',
      fail: 'Operation Fail',
      warning: 'Please input all required data',
      lastUpdateTime: 'Last Update Time of Sales Data',
      unSubmit: 'Open',
      submit: 'Submit',
      edit: 'Edit',
      cancel: 'Cancel'
    },
    form: {
      spName: 'SpName',
      asmEmp: 'ASM',
      rsmEmp: 'Region Head'
    },
    table: {
      asmEmp: 'ASM',
      rsmEmp: 'Region Head',
      spName: 'SpName',
      auditStatus: 'Status',
      orderQty: 'Order Qty',
      deliverQty: 'Deliver Qty',
      receiptQty: 'Receipt Qty',
      salesTargetQty: 'Monthly SOP',
      emeWeekTotalQty: 'Monthly EME',
      emeWeekOneQty: 'Week1 EME',
      emeWeekTwoQty: 'Week2 EME',
      emeWeekThreeQty: 'Week3 EME',
      emeWeekFourQty: 'Week4 EME',
      emeWeekFiveQty: 'Week5 EME',
      emeWeekChangeQty: 'Week6 EME',
      action: 'Action',
      approve: 'Approve',
      reject: 'Reject'
    }
  },
  oilAllowance: {
    BoxWrap: {
      manage: 'OilAllowance',
      list: 'OilAllowance'
    },
    common: {
      exportText: 'OilAllowance'
    },
    form: {
      no: 'No',
      name: 'Name',
      status: 'Status',
      date: 'Date'
    },
    table: {
      signRecordNo: 'signRecordNo',
      dateCycle: 'dateCycle',
      dayFormatted: 'dayFormatted',
      empNo: 'empNo',
      empName: 'empName',
      estimateDistance: 'estimateDistance',
      estimateAllowance: 'estimateAllowance',
      statusString: 'status',
      action: 'Action'
    },
    table2: {
      planTaskDate: '日期',
      empNo: '工号',
      empName: '姓名',
      planTaskTime: '计划时间',
      actualPlanTaskTime: '任务时间',
      planTaskType: '任务类型',
      category: '类型',
      checkInDateTime: '打卡时间',
      rtlSapId: '门店编号',
      rtlFullName: '门店名称',
      checkInAddress: '打卡地点',
      driveType: '出行方式',
      driveRemark: '出行备注',
      signType: '签到状态',
      auditRemark: '审批状态'
    },
    table3: {
      auditName: '审批人',
      auditTime: '审批时间',
      auditStatus: '审批状态',
      refuseReason: '审批意见'
    }
  },
  mealAllowance: {
    BoxWrap: {
      manage: 'MealAllowance',
      list: 'MealAllowance'
    },
    common: {
      exportText: 'MealAllowance',
      exportMealSupplementText: 'MealSupplement'
    },
    form: {
      no: 'No',
      name: 'Name',
      status: 'Status',
      date: 'Date',
      teamType: 'Team',
      optionPlaceholder: 'Please select'
    },
    table: {
      signRecordNo: '餐补编号',
      dateCycle: '日期周期',
      dayFormatted: '日期',
      empNo: '工号',
      empName: '姓名',
      planTaskType: '工作类型记录',
      combineAddress: '常住地',
      combineCheckInAddress: '最后任务打卡地点',
      taskCheckInDatetime: '最后任务打卡时间',
      checkInDatetime: '最晚打卡时间',
      totalMeal: '预估津贴',
      mealRemark: '餐补备注',
      action: '操作'
    }
  }
};